import { saveAs } from 'file-saver'
import moment from 'moment'
import PropTypes from 'prop-types'

import formatValueCsv from '../exportUtils'
import processRows from '../processRows'
import toXLSBlob from './toXLSBlob'

const processSummaryRows = (sumData) => {
  if (!sumData || !Array.isArray(sumData) || sumData.length === 0) {
    return []
  }

  return sumData.map((summary) => {
    const headers = (summary.columns || []).map((c) => c.title)

    const rows = (summary.dataSource || []).map((record) =>
      (summary.columns || []).map((col) => formatValueCsv(record[col.dataIndex], col, record))
    )

    return {
      title: summary.title,
      headers,
      rows
    }
  })
}

const generateHTMLTable = (headers, rows, title = null) => {
  const titleHtml = title ? `<tr><td colspan="${headers.length}" style="font-weight:bold;">${title}</td></tr>` : ''

  const headerHtml = headers.length > 0 ? `<tr>${headers.map((h) => `<th>${h}</th>`).join('')}</tr>` : ''

  const bodyHtml = rows.map((row) => `<tr>${row.map((cell) => `<td>${cell}</td>`).join('')}</tr>`).join('')

  return `
    <table>
      <thead>
        ${titleHtml}
        ${headerHtml}
      </thead>
      <tbody>${bodyHtml}</tbody>
    </table>
  `
}

const exportToXLS = ({ columns, dataSource, reportName, exportDetails = false, sumData = [] }) => {
  const detailColumnDef = columns.find((col) => col.columns)

  const mainColumns = columns.filter((col) => (!col.columns || col.columns.length === 0) && col.exportable !== false)

  const detailColumns = detailColumnDef ? detailColumnDef.columns.filter((col) => col.exportable !== false) : []

  const activeColumns = exportDetails ? [...mainColumns, ...detailColumns] : mainColumns

  const mainHeaders = activeColumns.map((col) => col.title)
  const mainRows = processRows({
    dataSource,
    mainColumns,
    detailColumns,
    activeColumns,
    exportDetails
  })

  const mainTableHtml = generateHTMLTable(mainHeaders, mainRows)

  const summaries = processSummaryRows(sumData)
  const summaryTablesHtml = summaries
    .map((summary) => `<br/><br/>${generateHTMLTable(summary.headers, summary.rows, summary.title)}`)
    .join('')

  const finalContent = `${mainTableHtml}${summaryTablesHtml}`
  const reportTimeStamp = moment().format('DD_MM_YYYY_HH_mm_ss')

  const blob = toXLSBlob(finalContent)
  saveAs(blob, `relatorio_${reportName}_${reportTimeStamp}.xls`)
}

exportToXLS.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      dataIndex: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    })
  ).isRequired,
  dataSource: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])))
    .isRequired,
  reportName: PropTypes.string.isRequired,
  exportDetails: PropTypes.bool,
  sumData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      columns: PropTypes.arrayOf(
        PropTypes.shape({
          dataIndex: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired
        })
      ).isRequired,
      dataSource: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])))
        .isRequired
    })
  )
}

exportToXLS.defaultProps = {
  exportDetails: false,
  sumData: []
}

export default exportToXLS
